export const listTechnical = {
    frontend: [
        {
            title: 'React',
            products: [
                {
                    name: 'Typescript',
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    logo: '/images/svg/development-expertise/frontend/ts.svg',
                },
                {
                    name: 'Next.js',
                    logo: '/images/svg/development-expertise/frontend/next.svg',
                },
                {
                    name: 'React',
                    logo: '/images/svg/development-expertise/frontend/react.svg',
                },
                {
                    name: 'Eslint',
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    logo: '/images/svg/development-expertise/frontend/eslint.svg',
                },
                {
                    name: 'MobX',
                    logo: '/images/pic/development-expertise/mobx.jpg',
                },
                {
                    name: 'Redux',
                    logo: '/images/svg/development-expertise/frontend/redux.svg',
                },
                {
                    name: 'React Testing Library',
                    logo: '/images/pic/development-expertise/react-testing.jpg',
                },
                {
                    name: 'tanStack Query',
                    logo: '/images/svg/development-expertise/frontend/tan-stack.svg',
                },
            ],
        },
        {
            title: 'Vue',
            products: [
                {
                    name: 'Typescript',
                    logo: '/images/svg/development-expertise/frontend/ts.svg',
                },
                {
                    name: 'Nuxt.js',
                    logo: '/images/svg/development-expertise/frontend/nuxt.svg',
                },
                {
                    name: 'Vue.js',
                    logo: '/images/svg/development-expertise/frontend/vue.svg',
                },
                {
                    name: 'Pinia',
                    logo: '/images/svg/development-expertise/frontend/pinia.svg',
                },
                {
                    name: 'tanStack Query',
                    logo: '/images/svg/development-expertise/frontend/tan-stack.svg',
                },
                {
                    name: 'Storybook',
                    logo: '/images/svg/development-expertise/frontend/storybook.svg',
                },
                {
                    name: 'Eslint',
                    logo: '/images/svg/development-expertise/frontend/eslint.svg',
                },
            ],
        },
        {
            title: 'Vanilla / jQuery',
            products: [
                {
                    name: 'Typescript',
                    logo: '/images/svg/development-expertise/frontend/ts.svg',
                },
                {
                    name: 'Eslint',
                    logo: '/images/svg/development-expertise/frontend/eslint.svg',
                },
                {
                    name: 'Storybook',
                    logo: '/images/svg/development-expertise/frontend/storybook.svg',
                },
            ],
        },
    ],
    backend: [
        {
            title: 'PHP',
            products: [
                {
                    name: '1C-Bitrix',
                    logo: '/images/svg/development-expertise/backend/bitrix.svg',
                },
                {
                    name: 'Ensi',
                    logo: '/images/svg/development-expertise/backend/ensi.svg',
                },
                {
                    name: 'Symfony',
                    logo: '/images/svg/development-expertise/backend/symfony.svg',
                },
                {
                    name: 'Laravel',
                    logo: '/images/svg/development-expertise/backend/laravel.svg',
                },
                {
                    name: 'YII2',
                    logo: '/images/svg/development-expertise/backend/yii2.svg',
                },
                {
                    name: 'PHPUnit',
                    logo: '/images/svg/development-expertise/backend/phpunit.svg',
                },
            ],
        },
        {
            title: 'Nodejs',
            products: [
                {
                    name: 'NestJS',
                    logo: '/images/svg/development-expertise/backend/nestjs.svg',
                },
            ],
        },
        {
            title: 'Java',
            products: [
                {
                    name: 'Spring',
                    logo: '/images/svg/development-expertise/backend/spring.svg',
                },
                {
                    name: 'Hibernate',
                    logo: '/images/svg/development-expertise/backend/hibernate.svg',
                },
            ],
        },
        {
            title: 'Go',
            products: [
                {
                    name: 'Gin',
                    logo: '/images/svg/development-expertise/backend/gin.svg',
                },
                {
                    name: 'Go-zero',
                    logo: '/images/pic/development-expertise/go-zero.jpg',
                },
            ],
        },
    ],
    devops: [
        {
            title: '',
            products: [
                {
                    name: 'Docker',
                    logo: '/images/svg/development-expertise/devops/docker.svg',
                },
                {
                    name: 'lxc/lxd',
                    logo: '/images/pic/development-expertise/lxs.jpg',
                },
                {
                    name: 'Kubernetes',
                    logo: '/images/svg/development-expertise/devops/kuber.svg',
                },
                {
                    name: 'Istio',
                    logo: '/images/svg/development-expertise/devops/istio.svg',
                },
                {
                    name: 'Prometheus',
                    logo: '/images/svg/development-expertise/devops/prometeus.svg',
                },
                {
                    name: 'grafana/grafanaOnCall/Loki',
                    logo: '/images/svg/development-expertise/devops/grafana.svg',
                },
                {
                    name: 'ELK/EFK',
                    logo: '',
                },
                {
                    name: 'Ansible',
                    logo: '/images/svg/development-expertise/devops/ansible.svg',
                },
                {
                    name: 'Terraform',
                    logo: '/images/svg/development-expertise/devops/terraform.svg',
                },
                {
                    name: 'Rancher/k3s',
                    logo: '/images/svg/development-expertise/devops/rancher.svg',
                },
                {
                    name: 'Gitlab/CI',
                    logo: '/images/svg/development-expertise/devops/gitlab.svg',
                },
                {
                    name: 'Yandex Cloud',
                    logo: '/images/svg/development-expertise/devops/yandex.svg',
                },
                {
                    name: 'RabbitMQ',
                    logo: '/images/svg/development-expertise/devops/rabbit.svg',
                },
                {
                    name: 'MySQL',
                    logo: '/images/svg/development-expertise/devops/mysql.svg',
                },
                {
                    name: 'Postgresql',
                    logo: '/images/pic/development-expertise/postgres.jpg',
                },
                {
                    name: 'ClickHouse',
                    logo: '/images/pic/development-expertise/clickhouse.jpg',
                },
                {
                    name: 'Sentry',
                    logo: '/images/svg/development-expertise/devops/sentry.svg',
                },
                {
                    name: 'ProxySql',
                    logo: '/images/pic/development-expertise/proxysql.jpg',
                },
                {
                    name: 'Redis/Memcached',
                    logo: '/images/svg/development-expertise/devops/redis.svg',
                },
                {
                    name: 'KeyCloack',
                    logo: '/images/svg/development-expertise/devops/keycloack.svg',
                },
                {
                    name: 'Jaeger',
                    logo: '/images/pic/development-expertise/jaeger.jpg',
                },
                {
                    name: 'Haproxy',
                    logo: '/images/pic/development-expertise/haproxy.jpg',
                },
            ],
            content:
                'Внедряем мониторинг, обеспечиваем техническую поддержку 24/7 и&nbsp;поддерживаем' +
                ' бесперебойную работоспособность сервисов',
        },
    ],
    qa: [
        {
            title: '',
            products: [
                {
                    name: 'NodeJS',
                    logo: '/images/svg/development-expertise/qa/nodejs.svg',
                },
                {
                    name: 'Playwright',
                    logo: '/images/svg/development-expertise/qa/playwright.svg',
                },
                {
                    name: 'Jest',
                    logo: '/images/svg/development-expertise/qa/jest.svg',
                },
                {
                    name: 'Mocha',
                    logo: '/images/svg/development-expertise/qa/mocha.svg',
                },
                {
                    name: 'Typescript',
                    logo: '/images/svg/development-expertise/frontend/ts.svg',
                },
                {
                    name: 'JMeter',
                    logo: '/images/svg/development-expertise/qa/jmetter.svg',
                },
                {
                    name: 'PactJS',
                    logo: '/images/pic/development-expertise/pactjs.jpg',
                },
                {
                    name: 'Postman',
                    logo: '/images/svg/development-expertise/qa/postman.svg',
                },
                {
                    name: 'K6',
                    logo: '/images/svg/development-expertise/qa/k6.svg',
                },
                {
                    name: 'Artillery',
                    logo: '/images/svg/development-expertise/qa/artillery.svg',
                },
                {
                    name: 'Qase',
                    logo: '/images/svg/development-expertise/qa/qase.svg',
                },
                {
                    name: 'Charls',
                    logo: '/images/pic/development-expertise/charls.jpg',
                },
            ],
        },
    ],
};
